import { render, staticRenderFns } from "./pointTask.vue?vue&type=template&id=34fd6910&scoped=true"
import script from "./pointTask.vue?vue&type=script&lang=js"
export * from "./pointTask.vue?vue&type=script&lang=js"
import style0 from "./pointTask.vue?vue&type=style&index=0&id=34fd6910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fd6910",
  null
  
)

export default component.exports